import { ReactNode, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [isWrapped, setIsWrapped] = useState(false);

  const toggleWrapper = () => {
    setIsWrapped(!isWrapped);
  };

  return (
    <>
      <Header onToggleSidebar={toggleWrapper} />
      <div className={`wrapper ${isWrapped ? "wrapped" : ""}`}>
        <Sidebar />
        <div className="main">
          <div className="d-flex justify-content-end">
            
          </div>

          <main className="content">{children}</main>

          <Footer />
        </div>
      </div>
    </>
  );
}
